<template>
  <SimulationTemplate v-if="form !== null" :form="form" />
</template>

<script>
import SimulationTemplate from '@/components/Shared/Simulation/SimulationTemplate.vue'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeLoginLp } from '@/mixins/setDrawerTypeLoginLp'
import { setToolBarTypeLoginLp } from '@/mixins/setToolBarTypeLoginLp'
import { mapActions } from 'vuex'
import { modes } from '@/vuex/modules/simulation/constants'
import { createFormFactory } from '@/models/Simulation'

export default {
  name: 'SimulationModel',
  components: {
    SimulationTemplate,
  },
  mixins: [accountInitializer, setDrawerTypeLoginLp, setToolBarTypeLoginLp],
  data() {
    return {
      form: null,
    }
  },
  async created() {
    await this.mode(modes.ADD)
    await this.getFormData()
  },
  methods: {
    ...mapActions('simulation', {
      mode: 'MODE',
    }),
    async getFormData() {
      /**
       * 読み取り専用からコピーして作成する場合は
       * 引き継いだFormを適用する
       */
      const passedForm = this.$route.params.passedForm

      if (passedForm) {
        const { basicSetting, deliverySetting } = passedForm

        // 引き継いではいけない情報をundefinedで上書き
        basicSetting.advertiserId = undefined
        basicSetting.id = undefined
        basicSetting.hashId = undefined
        basicSetting.isReadOnly = false
        basicSetting.e2eResultHash = undefined

        const { menuSetting } = deliverySetting
        menuSetting.id = undefined
        const { simulationCustomLocationGroups } = menuSetting
        const { simulationPoiLocationGroups } = menuSetting
        simulationCustomLocationGroups.simulationLocationGroups.forEach(
          group => {
            group.id = undefined
            group.simulationLocations.forEach(location => {
              location.id = undefined
            })
          },
        )
        simulationPoiLocationGroups.simulationLocationGroups.forEach(group => {
          group.id = undefined
          group.simulationLocations.forEach(location => {
            location.id = undefined
          })
        })

        this.form = passedForm
        return false
      }
      this.form = await createFormFactory(this.$route.params.advertiserId)
    },
  },
}
</script>

<style></style>
